import { Input, Output, EventEmitter } from '@angular/core';
import { Component } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup, Validators } from '@angular/forms';
import { FilterMailSchedule } from '../../filter-administration.model';
import { TranslationService } from '@sdbn/common';

@Component({
  selector: 'app-filter-mail-schedule-editor',
  templateUrl: './filter-mail-schedule-editor.component.html',
  styleUrls: ['./filter-mail-schedule-editor.component.scss']
})
export class FilterMailScheduleEditorComponent {

  formGroup = new FormGroup({
    timeOfDay: new FormControl('', []),
    recipients: new FormControl('', [Validators.required]),
    monday: new FormControl('', []),
    tuesday: new FormControl('', []),
    wednesday: new FormControl('', []),
    thursday: new FormControl('', []),
    friday: new FormControl('', []),
    saturday: new FormControl('', []),
    sunday: new FormControl('', []),
    exportType: new FormControl('', [Validators.required]),
    periodic: new FormControl('', []),
    periodicInterval: new FormControl('', []),
  },
  { validators: this.customValidator() });

  customValidator() {
    return (form: FormGroup) => {
      const error =
        form.get('periodic') && !form.get('periodicInterval').value
          ? { required: true }
          : null;
      form.get('periodicInterval').setErrors(error); //<--see the setErrors
      return error;
    };
  }

  filterMailSchedule: FilterMailSchedule;

  @Input('filterMailSchedule') set setFilterMailSchedule(filterMailSchedule: FilterMailSchedule) {
    this.filterMailSchedule = filterMailSchedule;
    const values = {
      timeOfDay: this.filterMailSchedule?.timeOfDay,
      recipients: this.filterMailSchedule?.recipients,
      monday: this.filterMailSchedule.monday,
      tuesday: this.filterMailSchedule.tuesday,
      wednesday: this.filterMailSchedule.wednesday,
      thursday: this.filterMailSchedule.thursday,
      friday: this.filterMailSchedule.friday,
      saturday: this.filterMailSchedule.saturday,
      sunday: this.filterMailSchedule.sunday,
      exportType: this.filterMailSchedule.exportType,
      periodic: this.filterMailSchedule.periodic,
      periodicInterval: this.filterMailSchedule.periodicInterval
    };
    this.formGroup.reset(values);
    this.formGroup.markAsPristine();
    this.fireFormStateChangedEvents();
  }

  @Output() entryChanged = new EventEmitter<void>()

  constructor(
    public translationService: TranslationService
  ) {

    this.formGroup.valueChanges.subscribe(
      values => {
        if (this.formGroup.dirty) {
          this.filterMailSchedule.timeOfDay = values.timeOfDay;
          this.filterMailSchedule.recipients = values.recipients;
          this.filterMailSchedule.monday = values.monday;
          this.filterMailSchedule.tuesday = values.tuesday;
          this.filterMailSchedule.wednesday = values.wednesday;
          this.filterMailSchedule.thursday = values.thursday;
          this.filterMailSchedule.friday = values.friday;
          this.filterMailSchedule.saturday = values.saturday;
          this.filterMailSchedule.sunday = values.sunday;
          this.filterMailSchedule.exportType = values.exportType;
          this.filterMailSchedule.periodic = values.periodic;
          this.filterMailSchedule.periodicInterval = values.periodicInterval;
          this.fireFormStateChangedEvents();
        }
      }
    );

  }

  private fireFormStateChangedEvents() {
    this.entryChanged.next();
  }
}
